
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Product {
  productId: string;
  name: string;
  image: string[];
  prices: any;
  stock_quantity: number;
  description: string;
  uom_value: number;
  [key: string]: any;
}

interface Category {
  _id: string;
  name: string;
  products: Product[];
}

interface ProductState {
  categories: Category[];
}

const initialState: ProductState = {
  categories: [],
};

const popularProduct = createSlice({
  name: 'popularProducts',
  initialState,
  reducers: {
    setProductData(state, action: PayloadAction<Category[]>) {
      state.categories = action.payload;
    },
    updateProduct(state, action: PayloadAction<{ categoryId: string; product: Product }>) {
      const { categoryId, product } = action.payload;
      const category = state.categories.find((cat) => cat._id === categoryId);
      if (category) {
        const index = category.products.findIndex((p) => p.productId === product.productId);
        if (index !== -1) {
          category.products[index] = product;
        }
      }
    },
  },
});

export const { setProductData, updateProduct } = popularProduct.actions;
export default popularProduct.reducer;
